var option_default = {
  "option": "e1ZkV",
  "user_choice": "_3SERq",
  "check": "rPq7r",
  "image": "KmYTs",
  "input": "JZP4h",
  "title": "ZG1Xy",
  "centered": "D6urd",
  "with_result": "W9foX",
  "list": "_5R2yX",
  "with_image": "_5ShRv",
  "progress": "CQf6I",
  "progress_value": "GXSrR",
  "label": "eJlIA",
  "cta": "q-auP",
  "adornment_icon": "L6XBv",
  "remove": "Z0VII",
  "removeButton": "kJ3ft",
  "removeButtonIcon": "zLFVy",
  "overlay": "PPpkV",
  "shown": "aPfxe",
  "dark": "S0zRK",
  "spinner": "cAQo8",
  "spin": "_6J1G5"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
